module.exports = __webpack_public_path__ + "static/media/mic_off-24px.ba53335f.svg";